var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFerry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 831,
    viewBox: "0 0 562 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8828_3525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.999 823L35.5 406L521.5 413.5L281.999 823Z",
    fill: "#62ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 277C558 429.983 433.983 554 281 554C128.017 554 4 429.983 4 277C4 124.017 128.017 0 281 0C433.983 0 558 124.017 558 277Z",
    fill: "#62ADEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.034 280.633H159.286H105L156.983 358.167H437.692L457 280.633H441.034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M433.236 228.359H407.987L396.106 192.713H364.916H315.485H259.464L268.375 161.523H257.979L237.185 192.713H205.996L159.286 264.004H441.033L433.236 228.359ZM234.215 239.938H216.393V222.116H234.215V239.938ZM277.287 239.938H259.464V222.116H277.287V239.938ZM320.358 239.938H302.536V222.116H320.358V239.938ZM358.975 239.938H341.152V222.116H358.975V239.938Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.915 139.836H324.814L321.583 155.28H364.915V139.836Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M364.915 164.188H319.714L315.485 184.389H364.915V164.188Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M441 406.568V388.466C431.443 388.457 422.171 391.015 414.749 395.707L403.831 403.129C397.177 407.658 387.253 407.658 380.6 403.129C377.115 400.956 373.863 398.422 370.378 396.069C353.831 385.31 329.778 385.31 313.231 396.069C309.514 398.422 306.029 401.137 302.312 403.491C295.659 408.02 285.735 408.02 279.082 403.491C275.365 401.137 271.88 398.422 268.163 396.069C251.655 385.41 227.755 385.41 211.248 396.069C207.531 398.422 204.511 400.956 200.794 403.129C198.65 404.439 196.206 405.422 193.592 406.025C186.732 407.274 179.54 405.545 174.775 401.5C169.023 397.627 162.886 394.117 156.423 391C151.092 388.772 145.005 387.886 139 388.466V406.568C144.046 407.195 148.648 409.18 152.009 412.18L159.211 417.068C174.933 427.147 197.442 427.594 213.803 418.154C218.217 415.438 222.166 412.361 226.58 409.646C233.233 405.116 243.157 405.116 249.811 409.646L258.871 415.982C275.1 427.314 299.46 427.85 316.483 417.249C319.968 415.076 322.988 412.723 326.24 410.551C333.309 405.073 344.725 405.073 351.794 410.551L360.854 416.887C372.249 424.354 387.692 426.87 401.972 423.585C410.851 421.7 418.891 417.942 425.203 412.723C429.224 409.132 434.9 406.919 441 406.568Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8828_3525",
    x: 0,
    y: 0,
    width: 562,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8828_3525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8828_3525",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerry);
export default __webpack_public_path__ + "static/media/ferry.28d04da303c9819366df02bc585de0d3.svg";
export { ForwardRef as ReactComponent };